var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCloudiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.063 6.892c.646-.924 2.136-2.392 5.011-2.392 2.029 0 3.457.945 4.34 2.154a6.28 6.28 0 0 1 1.133 2.868c.759.067 1.715.3 2.56.832 1.087.684 1.967 1.86 1.967 3.646 0 3.404-2.501 5-4.5 5H8.114c-1.477.11-4.04-.38-5.786-2.334C.99 15.167.611 13.546.785 12.106c.17-1.4.854-2.585 1.582-3.313.933-.933 2.176-1.45 3.284-1.705.856-.197 1.717-.258 2.412-.196zm5.011-.392c-2.443 0-3.338 1.43-3.535 1.8a1.24 1.24 0 0 1-1.365.626C7.794 8.841 7 8.83 6.1 9.037c-.89.205-1.74.591-2.319 1.17L3.074 9.5l.707.707c-.439.439-.899 1.221-1.01 2.14-.106.877.099 1.923 1.049 2.987 1.238 1.385 3.15 1.755 4.171 1.67L8.033 17h10.541c1.001 0 2.5-.804 2.5-3 0-1.014-.453-1.588-1.033-1.954-.634-.4-1.436-.546-1.967-.546h-.279a1.21 1.21 0 0 1-1.207-1.249c.02-.652-.211-1.626-.789-2.417-.547-.75-1.401-1.334-2.725-1.334z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloudiness);
export default __webpack_public_path__ + "static/media/ic_cloudiness.a27f8b54f82a297f59267a9a539b2154.svg";
export { ForwardRef as ReactComponent };